<template>
  <div :class="{'dh-psy-data-viz--series': true, 'dh-psy-data-viz--series-single': items.length === 1}">
    <div
      class="dh-psy-data-viz__wrapper"
      aria-hidden
    >
      <div
        v-for="(item, index) in items"
        :key="`${item.dataViz}-${index}`"
        class="dh-psy-data-viz__inner-wrapper"
      >
        <div :class="{'dh-psy-data-viz__svg-wrapper': true, 'dh-psy-data-viz__svg-wrapper--hidden': activeIndex < index, [`dh-psy-data-viz__svg-wrapper--${speed}`]: true}">
          <ImportedIllustration :id="item.dataViz" />
        </div>
      </div>
    </div>
    <Scroller
      @change="handleActiveChange"
      :root-margin="rootMargin"
    >
      <div
        slot="foreground"
        :class="['dh-psy-data-viz__description', `dh-psy-data-viz__description--${size}`]"
      >
        <DataVizDescription
          v-for="item in items"
          :key="item.description"
          :alt-text="item.altText"
          :description="item.description"
        />
      </div>
    </Scroller>
  </div>
</template>

<script>
import ImportedIllustration from './illustration.vue'
import DataVizDescription from './description.vue'
import Scroller from '../../Utilities/Scroller.vue'
import { globalEventStore } from '../../../lib/global-event-store'

function getAltText(item, idx) {
  try {
    if (item && item.value && item.value['alt-text'] && item.value['alt-text'][idx]) {
      return item.value['alt-text'][idx].value
    }
    return undefined
  } catch (_) {
    return undefined
  }
}

export default {
  props: ['item'],
  data() {
    return {
      activeIndex: 0
    }
  },
  computed: {
    rootMargin() {
      if (typeof window === 'undefined') return '-30% 0px -45%'
      if (window.innerHeight > window.innerWidth) return '-50px 0px -50px'

      return '-50px 0px -50px'
    },
    align() {
      return this.item.align
    },
    size() {
      return this.item.value.size || 'normal'
    },
    speed() {
      return this.item.value.speed || 'slow'
    },
    items() {
      return this.item.value['data-viz'].map((dataViz, idx) => ({
        dataViz: dataViz.value,
        altText: getAltText(this.item, idx),
        description: this.item.value.description[idx].value
      }))
    }
  },
  methods: {
    handleActiveChange(index) {
      if (index !== -1) {
        this.activeIndex = index

        globalEventStore.dispatch(this.$root.$data.id, 'sendGaEvent', {
          action: `DATA-VIZ_CHANGE/${index}`
        })
      }
    }
  },
  components: {
    ImportedIllustration,
    DataVizDescription,
    Scroller
  }
}
</script>

<style lang="postcss" scoped>
  .dh-psy-data-viz--series {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .dh-psy-data-viz__wrapper {
    height: 100vh;
    height: calc(100 * var(--dh-vh));
    position: sticky;
    top: 0;
  }

  .dh-psy-data-viz__inner-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    height: calc(100 * var(--dh-vh));
    width: 100%;

    @media (min-width: 800px) {
      width: 50%;
      max-width: 590px;
      box-sizing: border-box;
    }
  }

  .dh-psy-data-viz__svg-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: 0.75s opacity ease-in-out;
    will-change: opacity;

    &.dh-psy-data-viz__svg-wrapper--fast {
      transition: 0.5s opacity ease-in-out;
    }

    &.dh-psy-data-viz__svg-wrapper--hidden {
      opacity: 0;
    }

    & > div {
      width: 100%;
    }
  }

  :global(.dh-no-sticky) .dh-psy-data-viz--series {
    & .dh-psy-data-viz__wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding: 0 5%;
      width: 50%;
      max-width: 590px;
      width: 100%;
    }

    & .dh-psy-data-viz__inner-wrapper {
      position: relative;
      height: 75vh;
      width: 100%;
    }

    & .dh-psy-data-viz__svg-wrapper {
      height: 100%;
    }

    & .dh-psy-data-viz__svg-wrapper--hidden {
      opacity: 1;
    }

    & .dh-psy-data-viz__description-item {
      height: 75vh;
      height: calc(75 * var(--dh-vh));
      padding: 18px;
      margin: 0;
    }

    & .dh-psy-data-viz__description {
      padding-bottom: 5vh;
      padding-bottom: calc(5 * var(--dh-vh));
      margin: 0 0 auto auto;
    }
  }

  .dh-psy-data-viz__wrapper--left {
  }
  .dh-psy-data-viz__wrapper--right {
    @media (min-width: 800px) {
      order: 2;
    }
  }

  .dh-psy-data-viz__description {
    position: relative;
    width: 100%;
    margin: -33% 0 auto auto;
    padding-bottom: 50vh;
    padding-bottom: calc(50 * var(--dh-vh));
    box-sizing: border-box;

    @media (min-width: 800px) {
      margin: -33% 0 auto auto;
    }
  }

  .dh-psy-data-viz--series-single {
    & .dh-psy-data-viz__description {
      @media (min-width: 800px) {
        padding-bottom: 50vh;
        padding-bottom: calc(50 * var(--dh-vh));
      }
    }
  }
</style>
